import React from "react";
import { Input, Button } from "reactstrap";

function AmazonProductListingTabs({ tabs, activeTab, setActiveTab, search, setSearch }) {
  return (
    <div className="d-flex align-items-center justify-content-between w-100">
      
      <div className="brand-tabs d-flex align-items-center">
        {tabs.map(function (tab) {
          const isActive = activeTab === tab.key;

          return (
            <div
              key={tab.key}
              className={`main-tabs ${isActive ? "active" : ""}`}
              onClick={() => setActiveTab(tab.key)}
              style={{ cursor: "pointer" }}
            >
              {tab.label}
              <span className="tab-count"> ({tab.count})</span>
            </div>
          );
        })}
      </div>

      <div className="d-flex align-items-center justify-content-end flex-grow-1">
        <Input
          type="text"
          placeholder="Search fields..."
          value={search}
          className="w-50 me-2" 
          onChange={function (e) { setSearch(e.target.value); }}
        />
      </div>
      
    </div>
  );
}

export default AmazonProductListingTabs;